import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ToolboxSelectNsk = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    width,
    height,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      width={width}
      height={height}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M4.4402 22.8C4.4053 23.8726 5.8512 24.4223 6.5402 23.5946L11.9051 17.5196H4.4403L4.4402 22.8Z"
        fill={color}
      />
      <path
        d="M21.6094 15.4711L6.4887 0.35159C5.7827 -0.40651 4.4045 0.16249 4.4402 1.19999V17.5195H20.7609C21.7989 17.5539 22.3657 16.1799 21.6094 15.4711Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ToolboxSelectNsk.displayName = 'ToolboxSelectNsk';
